import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	const [input5, onChangeInput5] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2768,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 111,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 249,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4u8q1fjz_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g7f4ly1z_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e2we65xj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k0suhfbc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6bsv9cpj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 90,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uig04kj7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Chats"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 42,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tspz7xun_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bktlzib3_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m04kqhnf_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sr8egrvl_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fp90twnq_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k69fr896_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nbxml3kv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/latgl54p_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lj4rfi7w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w4vdq3bl_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xq8kemua_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/un9wj3nd_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k0neu5q6_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pkizykwc_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Chats"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 29,
								marginRight: 23,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 81,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 92,
									}} >
									{"All Chats"}
								</span>
								<span 
									style={{
										color: "#000000",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Groups"}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
								}}>
								<div 
									style={{
										width: 74,
										height: 3,
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderTopLeftRadius: 8,
										borderTopRightRadius: 9,
										marginRight: 57,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 225,
									marginBottom: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pkbwb7ub_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search chat..."}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 88,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kzl1ejtm_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 49,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Startup Strategy Hub"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Created On: March 1, 2025 • 8 Learners"}
									</span>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/prsleowj_expires_30_days.png"} 
									style={{
										width: 19,
										height: 19,
										marginTop: 30,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nd9d5at6_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 11,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Others Group"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Created On: March 1, 2025 • 8 Learners"}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"Yesterday"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
								}}>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1063,
								background: "#E6E6E6",
								marginRight: 24,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 10,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 518,
									}} >
									{"Create New Group"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ryn8dxh6_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 28,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 15,
									marginLeft: 8,
								}} >
								{"Fill Group Info"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 8,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 5,
										marginRight: 96,
									}}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Group Name"}
									</span>
									<input
										placeholder={"Enter group name"}
										value={input4}
										onChange={(event)=>onChangeInput4(event.target.value)}
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 20,
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 20,
											paddingRight: 20,
										}}
									/>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Description"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 16,
											paddingBottom: 70,
											paddingLeft: 20,
											paddingRight: 153,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"Write your description here..."}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 16,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zuedya06_expires_30_days.png"} 
										style={{
											width: 110,
											height: 110,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/el4ux6z9_expires_30_days.png"} 
											style={{
												width: 21,
												height: 21,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Add Group Photo"}
										</span>
									</div>
								</div>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 20,
									marginLeft: 8,
								}} >
								{"Add Learners"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 29,
									paddingRight: 368,
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/58rzrpja_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search learners..."}
									value={input5}
									onChange={(event)=>onChangeInput5(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 113,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 460,
									}} >
									{"2 Learners selected"}
								</span>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Unselect all"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jx4rmp3f_expires_30_days.png"} 
									style={{
										width: 50,
										height: 50,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#000000",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Arlene McCoy"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Joined Mar 20, 2025"}
									</span>
								</div>
								<div 
									style={{
										width: 118,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/48nx52fy_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 671,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 8,
									marginRight: 8,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ws1rwnqe_expires_30_days.png"} 
									style={{
										width: 50,
										height: 50,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#000000",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Albert Flores"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Joined Mar 20, 2025"}
									</span>
								</div>
								<div 
									style={{
										width: 118,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pcl0gmgi_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 671,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 8,
									marginRight: 8,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6b78jtqc_expires_30_days.png"} 
									style={{
										width: 50,
										height: 50,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#000000",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Marvin McKinney"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Joined Mar 20, 2025"}
									</span>
								</div>
								<div 
									style={{
										width: 135,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/52r7bm12_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 671,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 8,
									marginRight: 8,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ve3qv7rr_expires_30_days.png"} 
									style={{
										width: 50,
										height: 50,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#000000",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Courtney Henry"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Joined Mar 20, 2025"}
									</span>
								</div>
								<div 
									style={{
										width: 124,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ayyfn2x5_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 671,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 8,
									marginRight: 8,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 8,
									marginRight: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fnmvsmen_expires_30_days.png"} 
									style={{
										width: 50,
										height: 50,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#000000",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Ronald Richards"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Joined Mar 20, 2025"}
									</span>
								</div>
								<div 
									style={{
										width: 125,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0jfcwwck_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 671,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
									marginLeft: 8,
									marginRight: 8,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 278,
									paddingRight: 280,
									marginLeft: 8,
									marginRight: 8,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/an5fnj4b_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Create Group"}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}